import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 600 } }

  connect() {
    this._timer = null
    this._debouncedSubmit = this._debounce(() => this.submitNow(), this.delayValue)
  }

  disconnect() {
    if (this._timer) {
      clearTimeout(this._timer)
      this._timer = null
    }
  }

  handleInput() {
    this._debouncedSubmit()
  }

  handleChange() {
    this.submitNow()
  }

  handleBlur() {
    this.submitNow()
  }

  submitNow() {
    if (this._timer) {
      clearTimeout(this._timer)
      this._timer = null
    }
    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }

  _debounce(fn, wait) {
    return () => {
      if (this._timer) clearTimeout(this._timer)
      this._timer = setTimeout(fn, wait)
    }
  }
}
